module.exports = __webpack_public_path__ + "img/AUD-USD.a46bc794.png";